module.exports = __webpack_public_path__ + "media/packs/images/flags/NI-7fb6435ecc3f06bb5dd50a4134feebe2.svg";